var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-tooltip"},[_c('Icon',{staticClass:"base-tooltip__icon",attrs:{"name":_vm.icon}}),_c('div',{staticClass:"base-tooltip__txt"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }